<template>
  <div id="dia">
    <el-form
      :model="model"
      ref="addForm"
      :rules="formrules"
      label-width="120px"
      v-if="isShow"
      :inline-message="true"
      class="dia_form"
    >
      <template>
        <el-row
          v-for="(item, index) in config"
          :key="index"
          :gutter="item.gutter"
        >
          <el-col
            v-for="(opt, num) in item.formItem"
            :key="num"
            :span="opt.span"
          >
            <el-form-item v-if="opt.itemType === 'checkbox'" label-width="40px">
              <el-checkbox v-model="model[opt.field1]">是否默认</el-checkbox>
              <el-checkbox v-model="model[opt.field2]">是否启用</el-checkbox>
            </el-form-item>
            <el-form-item
              v-else
              :label="opt.title + ':'"
              :label-width="opt.labelwidth ? opt.labelwidth + 'px' : ''"
              :prop="opt.field"
              :style="{ 'margin-top': opt.itemType === 'upload' ? '10px' : '' }"
            >
              <template v-if="opt.itemType == 'select'">
                <el-select
                  v-model="model[opt.field]"
                  :placeholder="opt.placeholder"
                  clearable
                  :disabled="opt.disabled || false"
                  @change="change($event, opt.selectChange)"
                  style="position: relative"
                >
                  <el-option
                    v-for="(e, i) in opt.options"
                    :key="i"
                    :label="e[opt.setLabel] || e.label"
                    :value="e[opt.setValue] || e.val"
                  />
                </el-select>
              </template>
              <template v-if="opt.itemType == 'input'">
                <el-input
                  v-model="model[opt.field]"
                  :placeholder="opt.placeholder"
                  :disabled="opt.disabled || false"
                  clearable
                />
              </template>
              <template v-if="opt.itemType == 'input_icon'">
                <el-input
                  v-model="model[opt.field]"
                  :placeholder="opt.placeholder"
                  :disabled="opt.disabled || false"
                  clearable
                >
                  <el-button
                    slot="prepend"
                    icon="el-icon-mobile-phone"
                    @click="countMoney(opt.clickName)"
                  />
                </el-input>
              </template>
              <template v-if="opt.itemType == 'datetime'">
                <el-date-picker
                  v-model="model[opt.field]"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="opt.placeholder"
                />
              </template>
              <template v-if="opt.itemType == 'date'">
                <el-date-picker
                  v-model="model[opt.field]"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="opt.placeholder"
                />
              </template>
              <template v-if="opt.itemType == 'textarea'">
                <el-input
                  style="margin-bottom: 8px"
                  type="textarea"
                  rows="2"
                  v-model="model[opt.field]"
                />
              </template>
              <template v-if="opt.itemType == 'upload'">
                <slot :name="opt.slot"></slot>
              </template>
              <template v-if="opt.itemType == 'selectload'">
                <slot :name="opt.slot"></slot>
              </template>
              <template v-if="opt.itemType == 'selectloadmore'">
                <!-- @clear 跟 :remote-method共用方法，当清空时以空值传出去-->
                <el-select
                  v-model="model[opt.field]"
                  :placeholder="opt.placeholder"
                  clearable
                  remote
                  filterable
                  :disabled="opt.disabled || false"
                  :remote-method="
                    (query) => {
                      remoteMethod(query, opt.remotemethod);
                    }
                  "
                  :loading="opt.loading"
                  v-loadmore:loadmore="opt.loadmoreMethod"
                  @change="change($event, opt.selectChange)"
                  @clear="remoteMethod('', opt.remotemethod)"
                  style="position: relative"
                >
                  <el-option
                    v-for="(e, i) in opt.options"
                    :key="i"
                    :label="e[opt.setLabel] || e.label"
                    :value="e[opt.setValue] || e.val"
                  />
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    diaFormConfig: {
      type: Array,
    },
    baseModel: {
      type: Object,
    },
    rules: {
      type: Object,
    },
    Reset: {
      type: Boolean,
    },
  },
  data() {
    return {
      config: this.diaFormConfig,
      model: this.baseModel,
      formrules: this.rules,
      isShow: this.Reset,
    };
  },
  emits: ["changeCallback"],
  watch: {
    baseModel: {
      handler(nv, ov) {
        this.model = nv;
      },
      deep: true, // 可以深度检测到 obj 对象的属性值的变化
    },
    Reset: {
      handler(nv, ov) {
        this.isShow = nv;
      },
      deep: true, // 可以深度检测到 obj 对象的属性值的变化
    },
  },
  methods: {
    change(val, name) {
      if (name) {
        this.$emit("changeCallback", val, name);
      }
    },

    // 远程搜索
    remoteMethod(e, name) {
      this.$emit("changeCallback", e, name);
    },
    // 计算金额
    countMoney(name) {
      this.$emit("changeCallback", "", name);
    },
    // 滚动条加载更多
    loadmore(e) {
      this.$emit("changeCallback", "", e);
    },
  },
};
</script>
<style scoped lang="less">
#dia {
  padding: 20px;
  .dia_form {
    .el-row {
      .el-form-item {
        margin-bottom: 0px;
        min-width: 230px;
        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
      }
    }
  }
}
/deep/ .el-select {
  width: 100%;
}
</style>
